import { createRoot } from 'react-dom/client';
import { App } from '@/app/bootstrap/App';
import { loadRuntimeConfig, getRuntimeConfig } from '@/shared/runtimeConfig';
import '@/shared/lib/i18n';
// Self-hostovaný Inter + JetBrains Mono (bundlované do buildu) — nahrazuje závislost na
// Google Fonts CDN, aby se aplikace vždy vykreslila ve stejném fontu jako design systém
// (jinak fallback na Segoe UI, který renderuje větší/těžší než Inter). Rodiny 'Inter' a
// 'JetBrains Mono' odpovídají tokenům --phx-font-sans / --phx-font-mono.
import '@fontsource/inter/400.css';
import '@fontsource/inter/400-italic.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
// 600 je potřeba mít jako skutečný řez: mono se používá i v semibold (směrování, kódy linek v matici)
// a bez něj si prohlížeč tučnost dopočítá sám — faux bold vypadá výrazně těžší než pravý SemiBold.
import '@fontsource/jetbrains-mono/600.css';
import './index.css';
import { StrictMode } from 'react';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Načteme runtime config z backendu před renderem — komponenty (MagicControlBridge,
// magicUrl helpery, phoenixOnTopConfig) ho čtou synchronně a předpokládají, že už je
// inicializovaný. Pokud fetch selže, loader vrátí prázdné defaulty a app pokračuje
// bez Phoenix-On-Top režimu.
void loadRuntimeConfig().finally(() => {
  const title = getRuntimeConfig().ui.title;
  if (title) document.title = title;

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
